import { Box, Button } from '@chakra-ui/react';
import { useEffect } from 'react';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useGet3thPartyServices, useGetOneService } from 'shared/api/requests/services';
import Card from 'shared/components/horizon-ui/card/Card';
import { HSeparator } from 'shared/components/horizon-ui/separator/Separator';
import Link from 'shared/components/Link';
import {
  CreateFormT,
  createResolver,
  getCreateValues,
} from 'shared/form-values/groups';
import useGetColors from 'shared/hooks/useGetColors';
import { PathsE, PathsParams } from 'shared/routes';
import { fillFormErrors } from 'shared/utils/devUtils';
import Form from './Form';
import { useParams } from 'react-router-dom';
import PageTitle from 'shared/views/admin/PageTitle';

const Create = () => {
  const { t } = useTranslation();
  const { serviceId } = useParams<PathsParams[PathsE.CREATE_GROUP]>();

  const { data: currentService } = useGetOneService({
    pathParams: { serviceId },
    params: undefined
  });
  const { useCreateGroup } = useGet3thPartyServices({
    domain: currentService?.domain,
    token: currentService?.token,
  });
  const { mutate, isPending } = useCreateGroup({
    pathParams: { serviceId },
    params: undefined
  });
  const { gray800, white, gray100, brand500, brand400 } = useGetColors();
  const methods = useForm<CreateFormT>({
    defaultValues: getCreateValues(),
    resolver: createResolver,
    mode: "onChange"
  });
  const { formState: { isValid }, trigger } = methods;

  useEffect(() => {
    trigger();
  }, []);

  const onSubmit: SubmitHandler<CreateFormT> = (values) => mutate(values, { onError: (error) => fillFormErrors(methods.setError, error) });

  const breadcrumbs = [
    {
      path: PathsE.HOME,
      text: t('general.home'),
    },
    {
      path: PathsE.GROUPS,
      text: t('services.groups'),
      pathsParams: {
        serviceId,
      },
    },
  ]

  return (
    <Box>
      <PageTitle title={t('services.createGroup')} breadcrumbs={breadcrumbs} backUrl={{
        path: PathsE.GROUPS
      }} />
      <Card mb="20px" borderRadius="20px" px="30px">
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <Form />
            <HSeparator my="20px" mx="-20px" width="calc(100% + 40px)" />
            <Link path={PathsE.GROUPS} pathsParams={{ serviceId }}>
              <Button
                color={gray800}
                bgColor={gray100}
                borderRadius="8px"
                w="100px"
              >
                Cancel
              </Button>
            </Link>
            <Button
              color={white}
              borderRadius="8px"
              _hover={{
                bgColor: brand400,
              }}
              bgColor={brand500}
              ml="20px"
              isLoading={isPending}
              w="100px"
              type="submit"
              isDisabled={!isValid}
            >
              Create
            </Button>
          </form>
        </FormProvider>
      </Card>
    </Box>
  );
};

export default Create;
